<template>
  <el-select
    :value="value"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.title"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { wikiList } from '@/service/getData'

export default {
  props: {
    value: '',
    type: Number,
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.value) {
      this.requestData('default')
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          keyword: query == 'default' ? '' : query,
          id: query == 'default' ? this.value : 0,
          type: this.type,
          size: 20,
          status: 2,
        }

        let res = await wikiList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>